'use strict';
// The one sentence the voice-memo detail panel shows after a commit. CommonJS so
// Jest can require it directly (the ESM page imports it through the .js
// re-export sibling). Pure — no React, no fetch.
//
// Why it is a helper at all: a memo committed with "Create + send now" passes
// `delivery:'send'` to createAllOrders, and the panel said "… and sent". Since
// owner ruling O59 a HOME DRAW never transmits from that dispatch — it is filed
// as an unsigned draft addressed to Quest, and only the card's Review & send →
// Confirm & fax, under the rendered PDF, can fax it. So a batch that contained a
// home draw was claiming a send that did not happen, which is exactly what
// routes/smsChat.js's own rule forbids ("never report an order as transmitted
// when it was not"). Everything else in that batch DID send, so the sentence
// keeps "and sent" and names the exception.

// commitPayload: { orderIds: [...], types: ['lab','quest_homebound',…],
//                  delivery: 'send'|'draft'|undefined }
function commitBannerText(commitPayload) {
  const p = commitPayload && typeof commitPayload === 'object' ? commitPayload : {};
  const ids = Array.isArray(p.orderIds) ? p.orderIds : [];
  const types = Array.isArray(p.types) ? p.types.filter(Boolean) : [];
  const count = ids.length ? String(ids.length) : '?';
  const plural = ids.length === 1 ? '' : 's';
  const typeList = types.length ? ` (${[...new Set(types)].join(', ')})` : '';
  const homeDraw = types.includes('quest_homebound');
  // "and sent" only when something in the batch actually transmitted. An
  // all-home-draw batch committed with "Create + send now" transmits NOTHING
  // (O59) — it files unsigned drafts — so the sentence must not claim a send at
  // all; the note below then carries the whole story.
  const sent = p.delivery === 'send' && types.some((t) => t !== 'quest_homebound');
  const sentPart = sent ? ' and sent' : '';
  // The exception rides in the same sentence, so the panel cannot be read as a
  // plain "it was faxed".
  // The note keys on what was ASKED for, not on `sent`: a provider who chose
  // "send now" on an all-home-draw batch is exactly who needs to be told why
  // nothing left the practice.
  const draftNote = (p.delivery === 'send' && homeDraw)
    ? ' The home draw is saved as an unsigned draft — fax it from Order Chat’s Review & send.'
    : '';
  return `${count} order draft${plural} created${typeList}${sentPart} — review and sign in Elation.${draftNote}`;
}

module.exports = { commitBannerText };
